<template>
  <div>
    <div>
      <img class="picture" src="../../assets/pictures/ZH.jpg" alt="" />
    </div>
    <div class="test00">
      <div class="test table-wrapper">
        <el-table :data="storageList">
          <el-table-column label="仓位编号" prop="StorageLocationNO"></el-table-column>
          <el-table-column label="所属仓库" prop="WarehouseName"></el-table-column>
          <el-table-column label="工件信息" prop="WorkpieceInfo"></el-table-column>
        </el-table>
      </div>
    </div>
    <div>
      <div class="test01 table-wrapper">
        <!-- 智能机器人轴关节数据 -->
        <el-table :data="robot01list" :show-header="false" :row-style="{height: '30px'}" style="font-size: 20px">
          <el-table-column label="产品类型" prop="VariableName"></el-table-column>
          <el-table-column label="总库存数量" prop="Value" align="center">
            <template slot-scope="scope">
              <div :style="{color: scope.row.isOverText ? '#00e676' : '#00e676'}">
                {{ scope.row.Value }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div>
      <div class="test02 table-wrapper">
        <!-- 仓储设备监控 -->
        <el-table :data="robot02list" :show-header="false" :row-style="{height: '30px'}" style="font-size: 20px">
          <el-table-column label="产品类型" prop="VariableName"></el-table-column>
          <el-table-column label="总库存数量" prop="Value" align="center">
            <template slot-scope="scope">
              <div :style="{color: scope.row.isOverText ? '#00e676' : '#00e676'}">
                {{ scope.row.Value }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div>
      <div class="test03 table-wrapper">
        <!-- 自主移动机器人数据 -->
        <el-table :data="robot03list" :show-header="false" :row-style="{height: '30px'}" style="font-size: 20px">
          <el-table-column label="产品类型" prop="VariableName"></el-table-column>
          <el-table-column label="总库存数量" prop="Value" align="center">
            <template slot-scope="scope">
              <div :style="{color: scope.row.isOverText ? '#00e676' : '#00e676'}">
                {{ scope.row.Value }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div>
      <div class="test04 table-wrapper">
        <!-- rfid -->
        <el-table :data="robot04list" :show-header="false" :row-style="{height: '30px'}" style="font-size: 20px">
          <el-table-column label="产品类型" prop="VariableName"></el-table-column>
          <el-table-column label="总库存数量" prop="Value" align="center">
            <template slot-scope="scope">
              <div :style="{color: scope.row.isOverText ? '#00e676' : '#00e676'}">
                {{ scope.row.Value }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                page: '1',
                limit: '15',
                code1: 'IntelligentRobot',
                code2: 'Storage',
                code3: 'MobileRobot',
                code4: 'Assemble_RFID',
                code5: 'Assemble',
                code5: 'VisualDeviceStatus'
            },
            // 机器人轴关节数据
            robot01list: [],
            // 仓储设备信息数据
            robot02list: [],
            // 自主移动机器人数据
            robot03list: [],
            // RFID数据
            robot04list: [],
            // 仓库储位信息
            storageList: [],
            // 视觉设备状态信息
            robot05list: []
        }
    },
    created () {
        this.getStorageList()
        this.getRobot01()
        this.getRobot03()
        this.getRobot02()
        this.getRobot04()
        this.getRobot05()
    },
    mounted () {
        this.timer = setInterval(() => {
            this.getStorageList()
            this.getRobot01()
            this.getRobot03()
            this.getRobot02()
            this.getRobot04()
            this.getRobot05()
        }, 2000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(timer);
        })
    },
    beforeDestroy () {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        //调用接口获取仓库储位信息
        async getStorageList () {
            let params = new URLSearchParams();
            params.append("limit", this.getTypeList.limit)
            params.append("page", this.getTypeList.page)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryStorageLocation', { params })
            console.log(res.data)
            this.storageList = res.data
        },
        //调用接口获取智能机器人关节轴数据
        async getRobot01 () {
            let params = new URLSearchParams();
            params.append("code", this.getTypeList.code1)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryVariable', { params })
            console.log(res)
            console.log(res.data)
            this.robot01list = res.data
        },
        //调用接口获取仓储设备信息
        async getRobot02 () {
            let params = new URLSearchParams();
            params.append("code", this.getTypeList.code2)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryVariable', { params })
            console.log(res.data)
            this.robot02list = res.data
        },
        //调用接口获取自主移动机器人运行信息
        async getRobot03 () {
            let params = new URLSearchParams();
            params.append("code", this.getTypeList.code3)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryVariable', { params })
            console.log(res.data)
            this.robot03list = res.data
        },
        //调用接口获取RFID
        async getRobot04 () {
            let params = new URLSearchParams();
            params.append("code", this.getTypeList.code4)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryVariable', { params })
            console.log(res.data)
            this.robot04list = res.data
        },
        //调用接口获取视觉设备状态
        async getRobot05 () {
            let params = new URLSearchParams();
            params.append("code", this.getTypeList.code5)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/queryVariable', { params })
            console.log(res.data)
            this.robot05list = res.data
        },
    },

}
</script>

<style lang="less" scoped>
.picture {
  background-size: 100% 100%;
  position: fixed;
  width: 100%;
  height: 100%;
}
.test {
  width: 35%;
  height: 20%;
  position: absolute;
  left: 23%;
  top: 23%;
  transform: translate(-50%, -50%);
}
/**表格背景透明 */
//透明化整体
.table-wrapper /deep/ .el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}
//透明化行、单元格,删除表头下横线
.table-wrapper /deep/ tr,
.table-wrapper /deep/ th,
.table-wrapper /deep/ td {
  background: transparent !important;
  color: #fff;
  border-bottom: 0px; //删除表头下横线
}
//hover时样式
.table-wrapper /deep/ .el-table tbody tr:hover > td {
  background-color: transparent !important;
}
// 表格内容(有用)
.table-wrapper /deep/ .el-table__row {
  background: transparent !important;
  color: transparent;
}
.table-wrapper ::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
.table-wrapper ::v-deep .el-table td {
  border-bottom: 0px solid #dfe6ec !important;
}
.test01 {
  width: 25%;
  height: 20%;
  position: absolute;
  left: 58.5%;
  top: 20%;
  transform: translate(-50%, -50%);
}
.test02 {
  width: 25%;
  height: 20%;
  position: absolute;
  left: 58.5%;
  top: 58%;
  transform: translate(-50%, -50%);
}
.test03 {
  width: 25%;
  height: 20%;
  position: absolute;
  left: 89%;
  top: 20%;
  transform: translate(-50%, -50%);
}
.test04 {
  width: 27%;
  height: 20%;
  position: absolute;
  left: 60%;
  top: 96%;
  transform: translate(-50%, -50%);
}
</style>
